'use strict'

var NATIVE_STATE = require('../state').native;
var jsbridge = require("@tencent/txmv-core/jsbridge");
var fns = require('@tencent/fns')
window.__QQDOWNLOADERCALLBACK = function (ret) {
	document.dispatchEvent(new CustomEvent('qqdownloader:state_change', { detail: ret }));
};
jsbridge(function (suc) {
	if (suc) {
		window.mqq && window.mqq.invoke('q_download', 'registerDownloadCallBackListener', "__QQDOWNLOADERCALLBACK");
	}
});

//下载器各种状态
var DOWNLOADER_STATE = {
	//ENUM_NO_DOWNLOAD: 1,
	//ENUM_DOWNLOADING: 2,
	//ENUM_DOWNLOAD_PAUSE: 3,
	//ENUM_DOWNLOAD_SUC: 4,
	//ENUM_DOWNLOAD_FAIL: -1,
	//ENUM_INSTALLING: 5,
	//ENUM_INSTALL_SUCC: 6,
	//ENUM_INSTALL_COVER: 13,
	//ENUM_UNINSTALL: 9,
	//ENUM_WAITING: 20
	10: NATIVE_STATE.INSTALLING,
	1: NATIVE_STATE.NOTSURE,
	2: NATIVE_STATE.DOWNLOADING,
	3: NATIVE_STATE.PAUSE,
	4: NATIVE_STATE.DOWNLOADED,
	'-1': NATIVE_STATE.FAIL,
	5: NATIVE_STATE.INSTALLING,
	13: NATIVE_STATE.INSTALLED,
	6: NATIVE_STATE.INSTALLED,
	9: NATIVE_STATE.UNINSTALLED,
	20: NATIVE_STATE.DOWNLOADING
};
var ACTION_CODE = {
	DOWNLOAD: 2,
	CANCEL: 10,
	PAUSE: 3,
	INSTALL: 5,
	UPDATE: 12
};
module.exports = function (native, _callback) {
	var callbacked = false;
	//只callback一次
	var callback = function () {
		if (callbacked) {
			return;
		}
		callbacked = true;
		_callback.apply(this, arguments);
	};

	var qqVersion = function (j) {
		return j && j[1] || 0
	}(navigator.userAgent.match(/V1_AND_SQ_([\d\.]+)/));

	if (compareVersion(qqVersion, "4.5.0") < 0) {
		callback(null, null);
	}

	jsbridge(function (suc) {
		if (suc) {
			build(native, callback);
		} else {
			callback({}, null)
		}
	});

	setTimeout(function () {
		callback(null, null);
	}, 6000);
};

function build(native, callback) {
	//JsBridge.callMethod('q_download', 'getQueryDownloadAction', JSON.stringify([l_self.appId]), false);
	callback(null, factory(native));
}

var instanceCount = 0;
function factory(native) {
	//qqdownloader的属性
	var _progress = 0;
	var descriptor = {
		native: {
			value: native
		},
		appid: {
			value: native.package.appid + instanceCount++
		},
		url: {
			value: '',
			writable: true
		},
		confid: {
			value: '',
			writable: true
		},
		progress: {
			get: function () {
				return _progress
			},
			set: function (v) {
				_progress = v;
				native.emit('progress', v);
			}
		}
	};
	var obj = Object.create(proto, descriptor);

	//监听根元素上我们自己扩展的下载器状态变更事件
	//好像并没有用
	document.addEventListener('qqdownloader:state_change', function (e) {
		var res = e.detail;
		try {
			window[native.package['playerDownloadCallback']](res)
		} catch (e) { }
		console.log('qqdownloader:state_change', obj.appid, res);
		res = res[0] ? res : [res];

		res.forEach(function (v) {
			if (v.appid == obj.appid + obj.confid) {
				native.state = DOWNLOADER_STATE[res.state];
			}

		});
	});

	return obj;
}

//qqdownloader原型。
var proto = {
	start: function (cfg) {
		if (!cfg.confid || !cfg.url) {
			throw new Error('qq downloader:need confid and downloadurl');
		}

		this.confid = cfg.confid;
		this.url = cfg.url;

		var self = this;
		mqq.app.downloadApp(fns.extend({
			appid: this.appid,
			url: cfg.url,
			confid: this.confid,
			packageName: this.native.package.pkg,
			via: this.native.package.via,
			appName: this.native.package.name,
			actionCode: ACTION_CODE.DOWNLOAD
		}, this.native.package.qqdownload_extends), function (ret) {
			console.log(ret);
			if (!ret.errorCode) {
				self.native.state = DOWNLOADER_STATE[ret.state];
				if (ret.state == 4) {
					self.install()
				}
				self.progress = ret.pro;
			} else {
				self.native.state = NATIVE_STATE.FAIL;
			}
		});
	},
	pause: function () {
		var self = this;
		mqq.app.downloadApp(fns.extend({
			actionCode: ACTION_CODE.PAUSE,

			appid: this.appid,
			url: this.url,
			packageName: this.native.package.pkg,
			via: this.native.package.via,
			appName: this.native.package.name
		}, this.native.package.qqdownload_extends), function (ret) {
			console.log(ret);
			if (!ret.errorCode) {
				self.native.state = DOWNLOADER_STATE[ret.state];
				self.progress = ret.pro;
			} else {
				self.native.state = NATIVE_STATE.FAIL;
			}
		});
	},
	cancel: function () {
		var self = this;
		mqq.app.downloadApp(fns.extend({
			actionCode: ACTION_CODE.CANCEL,

			appid: this.appid,
			url: this.url,
			packageName: this.native.package.pkg,
			via: this.native.package.via,
			appName: this.native.package.name
		}, this.native.package.qqdownload_extends), function (ret) {
			console.log(ret);
			if (!ret.errorCode) {
				self.native.state = DOWNLOADER_STATE[ret.state];
				self.progress = ret.pro;
			} else {
				self.native.state = NATIVE_STATE.FAIL;
			}
		});
	},
	restart: function () {
		this.start();
	},
	install: function () {
		var self = this;
		mqq.app.downloadApp(fns.extend({
			actionCode: ACTION_CODE.INSTALL,

			appid: this.appid,
			url: this.url,
			packageName: this.native.package.pkg,
			via: this.native.package.via,
			appName: this.native.package.name
		}, this.native.package.qqdownload_extends), function (ret) {
			console.log(ret);
			if (!ret.errorCode) {
				self.native.state = DOWNLOADER_STATE[ret.state];
				self.progress = ret.pro;
			} else {
				self.native.state = NATIVE_STATE.FAIL;
			}
		});
	}
};


function compareVersion(h, f) {
	h = String(h).split(".");
	f = String(f).split(".");
	try {
		for (var j = 0, d = Math.max(h.length, f.length); j < d; j++) {
			var g = isFinite(h[j]) && Number(h[j]) || 0,
				k = isFinite(f[j]) && Number(f[j]) || 0;
			if (g < k) {
				return -1
			} else {
				if (g > k) {
					return 1
				}
			}
		}
	} catch (m) {
		return -1
	}
	return 0
}